// Converts a plant name into a clean, readable URL slug
// e.g. "Monstera Albo" -> "monstera-albo"
export const slugify = (name) => {
  if (!name) return '';
  return name
    .toString()
    .trim()
    .toLowerCase()
    .replace(/['"]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

// Converts a slug back into a space-separated search query for ilike matching
// e.g. "monstera-albo" -> "monstera albo"
export const unslugify = (slug) => {
  if (!slug) return '';
  return slug.replace(/-/g, ' ').trim();
};

// Builds a readable listing URL slug like "potted-6in-monstera-albo"
export const buildListingSlug = (listing) => {
  const parts = [];
  if (listing.sale_type) parts.push(slugify(listing.sale_type));
  if (listing.sale_size) parts.push(`${listing.sale_size}in`);
  if (listing.common_name) parts.push(slugify(listing.common_name));
  return parts.filter(Boolean).join('-') || 'listing';
};